"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseServiceInstrumentation = void 0;
const BaseInstrumentation_1 = require("./BaseInstrumentation");
class BaseServiceInstrumentation extends BaseInstrumentation_1.BaseInstrumentation {
    request;
    actor;
    startDate;
    extraArgs;
    constructor(config) {
        super(config);
        this.request = config.request;
        this.startDate = new Date();
        this.actor = config.actor;
        this.extraArgs = config.extraArgs ?? {};
    }
    /**
     * Add additional context to the instrumentation
     */
    hydrate(extraArgs) {
        this.extraArgs = {
            ...this.extraArgs,
            ...extraArgs,
        };
    }
    /**
     * Override the parent getServiceId to include timestamp for unique instance identification
     */
    getServiceId() {
        return `${super.getServiceId()}-${this.startDate.getTime()}`;
    }
    /**
     * Override the parent buildArguments to include request and actor context
     */
    buildArguments(args) {
        // Get the base arguments from the parent class
        const baseArgs = super.buildArguments(args);
        // Add request-specific context
        return {
            ...baseArgs,
            request: this.request,
            ...this.extraArgs,
            ...(this.actor && {
                actor: {
                    id: this.actor?.id,
                    type: this.actor?.type,
                    requestId: this.actor?.requestId,
                },
            }),
        };
    }
    /**
     * Log that the service has started
     */
    logStarted() {
        this.logInfo("Service started");
    }
    /**
     * Log that the service has ended
     */
    logEnded() {
        this.logInfo("Service ended");
    }
}
exports.BaseServiceInstrumentation = BaseServiceInstrumentation;
//# sourceMappingURL=BaseServiceInstrumentation.js.map